// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"batch-entry-fund-totals__container___31xwO","item":"batch-entry-fund-totals__item___HqBT2","name":"batch-entry-fund-totals__name___2qPm0","code":"batch-entry-fund-totals__code___300h5","notes":"batch-entry-fund-totals__notes___SbJXL","total":"batch-entry-fund-totals__total___1OCRa"};
    if(module.hot) {
      // 1773710318160
      var cssReload = require("../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  